export default __webpack_public_path__ + "assets/e8100ad6a637f4fb4bb9478bfebb9fa7/mosaic.png";